import {PolymerElement, html} from '@polymer/polymer';
import '@shoelace-style/shoelace/dist/components/animation/animation.js';

class KeliPanelContentPlaceholder extends PolymerElement {
  static get template() {
    return html`
<style>
  :host {
    position: absolute;
    top: 34px;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden;
    z-index: var(--keli-zindex-panel-placeholder);
    background-color: var(--keli-background-color);
    color: var(--keli-subtle-background);
    transition: color var(--keli-transition-slow);
  }

  :host(.long-loading) {
    color: var(--keli-text-subtle);
  }

  :host(.error) {
    color: var(--keli-invalid-text);
  }

  :host(.error) #loadingMessage {
    color: var(--keli-invalid-text);
  }

  #container {
    height: 100%;
    text-align: center;
  }

  #loadingContainer {
    position: relative;
    top: 50%;
    transform: perspective(1px) translateY(-50%);
  }

  #loadingIcon {
    display: inline-block;
    font-size: 96px;
  }

  #loadingMessage {
    color: var(--keli-background-color);
    font-weight: 300;
    text-transform: uppercase;
    margin: 0;
    transition: color var(--keli-transition-slow);
  }
  
  #forceClose {
    visibility: hidden;
    text-decoration: underline;
  }

  :host(.error) #forceClose {
    visibility: visible;
  }
</style>

<div id="container">
  <div id="loadingContainer">
    <sl-animation id="loadingIconAnimation" name="headShake" easing="ease" duration="2000" delay="2000" play>
        <sl-icon id="loadingIcon" name="keli"></sl-icon>
    </sl-animation>
    <p id="loadingMessage">Loading. Please wait.</p>
    <p id="forceClose"><keli-a on-click="handleForceClose">Force Close This Panel</keli-a></p>
  </div>
</div>`;
  }

  static get is() {
    return 'keli-panel-content-placeholder';
  }

  static get properties() {
    return {
      errorTimeout: {type: Number},
      errorState: {type: Boolean, observer: 'errorStateChanged'},
      startTime: Number
    }
  }

  connectedCallback() {
    super.connectedCallback();

    this.loadingTimeout = window.setTimeout(function () {
      this.classList.add('long-loading');
    }.bind(this), 5000);

    this.longLoadingTimeout = window.setTimeout(function () {
      this.$.loadingMessage.textContent = 'Still loading…';
    }.bind(this), 15000);

    if (this.errorTimeout) {
      this.reallyLongLoadingTimeout = window.setTimeout(function () {
        this.errorState = true;
      }.bind(this), parseInt(this.errorTimeout, 10));
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.clearAllTimeouts();
  }

  errorStateChanged(newValue) {
    if (newValue) {
      this.classList.add('error');
      this.$.loadingIconAnimation.cancel();
      this.$.loadingMessage.textContent = 'Something may have gone wrong. Please try again.';
      this.clearAllTimeouts();
    }
  }

  handleForceClose() {
    this.dispatchEvent(new CustomEvent('closePanel', {
      bubbles: true,
      composed: true,
      detail: {force: true}
    }));
  }

  clearAllTimeouts() {
    if (this.loadingTimeout) {
      window.clearTimeout(this.loadingTimeout);
    }
    if (this.longLoadingTimeout) {
      window.clearTimeout(this.longLoadingTimeout);
    }
    if (this.reallyLongLoadingTimeout) {
      window.clearTimeout(this.reallyLongLoadingTimeout);
    }
  }

  destroy() {
    this.remove();
  }
}

customElements.define(KeliPanelContentPlaceholder.is, KeliPanelContentPlaceholder);
export {KeliPanelContentPlaceholder};
